import { type DateTime } from "luxon";
import { type DateRange } from "@mui/x-date-pickers-pro";

import type { ReportingQueryParams } from "@/schemas";

const REPORTING_STALE_TIME_MS = 10 * 60 * 1000;
const REPORTING_GC_TIME_MS = 10 * 60 * 1000;

export const getReportingStaleTime = (dateFilter: DateRange<DateTime<boolean>>): number => {
	if (dateFilter[0]?.isValid !== true || dateFilter[1]?.isValid !== true) {
		return 0;
	}

	return REPORTING_STALE_TIME_MS;
};

export const getReportingGcTime = (dateFilter: DateRange<DateTime<boolean>>): number => {
	if (dateFilter[0]?.isValid !== true || dateFilter[1]?.isValid !== true) {
		return 0;
	}

	return REPORTING_GC_TIME_MS;
};

export const isValidReportingParams = (params: ReportingQueryParams): boolean => {
	return Boolean(
		params.sites?.length &&
		params.dateRange[0]?.isValid &&
		params.dateRange[1]?.isValid &&
		!params.dateRange[0].equals(params.dateRange[1]),
	);
};
